/*
 * Tencent is pleased to support the open source community by making TMagicEditor available.
 *
 * Copyright (C) 2021 THL A29 Limited, a Tencent company.  All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const log = (...args: any[]) => {
  if (process.env.NODE_ENV === 'development') {
    console.log('magic editor: ', ...args);
  }
};

export const info = (...args: any[]) => {
  if (process.env.NODE_ENV === 'development') {
    console.info('magic editor: ', ...args);
  }
};

export const warn = (...args: any[]) => {
  if (process.env.NODE_ENV === 'development') {
    console.warn('magic editor: ', ...args);
  }
};

export const debug = (...args: any[]) => {
  if (process.env.NODE_ENV === 'development') {
    console.debug('magic editor: ', ...args);
  }
};

export const error = (...args: any[]) => {
  if (process.env.NODE_ENV === 'development') {
    console.error('magic editor: ', ...args);
  }
};
